import { Component, OnInit } from '@angular/core';

/**
 * A generic page not found component
 */
@Component({
  selector: 'lm-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
  // TODO
  // reportProblem
  reportProblem() {}
}
